export class Tribunal{
    id = 0;
    descricao = '';
    situacao: Boolean;
}